/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { ImageEventType } from 'app/shared/model/enumerations/image-event-type.model';
import { ImageStatus } from 'app/shared/model/enumerations/image-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IEventImage {
  id?: string;
  eventId?: string | null;
  eventType?: keyof typeof ImageEventType | null;
  mediaName?: string | null;
  originalFilePath?: string | null;
  originalFileName?: string | null;
  message?: string | null;
  mimeType?: string | null;
  sortOrder?: number | null;
  status?: keyof typeof ImageStatus | null;
  addedById?: string | null;
  addedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string | null;
  modifiedByType?: keyof typeof AddedByType | null;
  active?: boolean;
  cursor?: number | null;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  patient?: IGlucoUser;
}

export const defaultValue: Readonly<IEventImage> = {
  active: false,
};
